import { useCidadaoDeclaracaoComparecimentoQuery } from 'graphql/hooks.generated'
import React, { useEffect } from 'react'
import { useParams } from 'react-router'

import { useListaAtendimentoActionsLoading } from '../../hooks/useListaAtendimentoActionsLoading'
import { GerarDeclaracaoComparecimentoModalForm } from './GerarDeclaracaoComparecimentoModalForm'

interface UrlParams {
  atendId: string
}

export function GerarDeclaracaoComparecimentoView() {
  const { atendId } = useParams<UrlParams>()
  const { stopLoading } = useListaAtendimentoActionsLoading()
  const { data } = useCidadaoDeclaracaoComparecimentoQuery({ variables: { id: atendId } })

  useEffect(stopLoading, [stopLoading])

  if (!data?.atendimento) {
    return null
  }
  return <GerarDeclaracaoComparecimentoModalForm {...data.atendimento} />
}
